import styled from 'styled-components';

import { baseBlue, green, lightBlue, red, white } from '~src/styles/colors';

export enum ButtonSizes {
  Medium = 'medium',
  MediumWide = 'mediumWide',
  Large = 'large',
  Wide = 'wide',
  Tiny = 'tiny',
}

type Sizes = 'tiny' | 'medium' | 'mediumWide' | 'large' | 'wide';

type ButtonColors = 'blue' | 'reddish' | 'white' | 'lightblue' | 'green';

export enum ButtonColorTypes {
  Blue = 'blue',
  Reddish = 'reddish',
  White = 'white',
  LightBlue = 'lightblue',
  Green = 'green',
}

export enum ButtonShape {
  Oval = 'oval',
  Rectangle = 'Rectangle',
}

type BtnColorsI = { [key in ButtonColors]: string };

// TODO REPLACE WITH THE NEW COLORS

export const buttonColors: BtnColorsI = {
  [ButtonColorTypes.Blue]: baseBlue.a10,
  [ButtonColorTypes.Reddish]: red.a10,
  [ButtonColorTypes.White]: white.a10,
  [ButtonColorTypes.LightBlue]: lightBlue.a10,
  [ButtonColorTypes.Green]: green.a10,
};

// TODO REPLACE WITH THE NEW COLORS

export const buttonFontColors: BtnColorsI = {
  [ButtonColorTypes.Blue]: white.a10,
  [ButtonColorTypes.Reddish]: white.a10,
  [ButtonColorTypes.White]: baseBlue.a10,
  [ButtonColorTypes.LightBlue]: white.a10,
  [ButtonColorTypes.Green]: white.a10,
};

export const buttonWidth = {
  [ButtonSizes.Tiny]: '80px',
  [ButtonSizes.Medium]: '120px',
  [ButtonSizes.MediumWide]: '100%',
  [ButtonSizes.Large]: '180px',
  [ButtonSizes.Wide]: '100%',
};

export const buttonHeight = {
  [ButtonSizes.Tiny]: 40,
  [ButtonSizes.Medium]: 45,
  [ButtonSizes.MediumWide]: 45,
  [ButtonSizes.Large]: 60,
  [ButtonSizes.Wide]: 60,
};

export const buttonPadding = {
  [ButtonSizes.Tiny]: 10,
  [ButtonSizes.Medium]: 30,
  [ButtonSizes.MediumWide]: 30,
  [ButtonSizes.Large]: 45,
  [ButtonSizes.Wide]: 45,
};

export const buttonFontSize: Record<string, string> = {
  [ButtonSizes.Tiny]: '.8rem',
};

export interface ButtonProps {
  $buttonColor?: ButtonColors;
  $buttonShape?: ButtonShape;
  $buttonSize?: Sizes;
  disabled?: boolean;
  $withBorder?: boolean;
  type?: 'reset'|'button'|'submit';
  $margin?: string;
  $highlighted?: boolean;
}

export const BaseButton = styled.button<ButtonProps>`
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${({ $buttonSize }) => (($buttonSize && buttonFontSize[$buttonSize]) ? buttonFontSize[$buttonSize] : '1rem')};
  line-height: 25px;
  border-radius: ${({ $buttonShape }) => ($buttonShape === ButtonShape.Rectangle ? '5px' : '50px')};
  padding: 0 ${({ $buttonSize }) => $buttonSize && buttonPadding[$buttonSize]}px;
  font-weight: 200;
  min-width: ${({ $buttonSize }) => $buttonSize && buttonWidth[$buttonSize]};
  height: ${({ $buttonSize }) => $buttonSize && buttonHeight[$buttonSize]}px;
  border: none;
  background-color: transparent;
  opacity: ${({ disabled }) => (disabled ? '0.4' : '1')};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  white-space: nowrap;
  ${({ $margin }) => `margin: ${$margin}`};

  &:focus {
    outline: 0;
  }
`;
